import NextIcon from "Assets/Img/NextIcon";
import Button from "../../../../Components/Common/Button/Button";

interface PublishBarProps {
  currentStep: number;
  totalSteps: number;
  label: string;
  nextLabel?: string;
  onBack: () => void;
  onNext: () => void;
  onSaveDraft: () => void;
  onPublish: () => void;
  isLast: boolean;
  loading?: boolean;
  savingDraft?: boolean;
}

const PublishBar = ({
  currentStep,
  totalSteps,
  label,
  nextLabel,
  onBack,
  onNext,
  onSaveDraft,
  onPublish,
  isLast,
  loading = false,
  savingDraft = false,
}: PublishBarProps) => {
  const busy = loading || savingDraft;

  return (
    <div className="publishBar">
      <div className="publishInfo">
        Step {currentStep} of {totalSteps} - {label}
      </div>
      <div className="publishActions">
        {currentStep > 1 ? (
          <Button className="btn btnSecondary" onClick={onBack} disabled={busy}>
            <span>Back</span>
          </Button>
        ) : null}
        <Button
          className="btn btnSecondary"
          onClick={onSaveDraft}
          disabled={busy}
        >
          {savingDraft && <span className="btnSpinner" />}
          <span>{savingDraft ? "Saving…" : "Save Draft"}</span>
        </Button>
        {!isLast ? (
          <Button className="btn btnPrimary" onClick={onNext} disabled={busy}>
            {loading ? (
              <>
                <span className="btnSpinner" />
                <span>Submitting…</span>
              </>
            ) : (
              <>
                <span>{nextLabel}</span> <NextIcon />
              </>
            )}
          </Button>
        ) : (
          <Button
            className="btn btnPublish"
            onClick={onPublish}
            disabled={busy}
          >
            {loading && <span className="btnSpinner" />}
            <span>{loading ? "Submitting…" : "Publish to Lender"}</span>
          </Button>
        )}
      </div>
    </div>
  );
};

export default PublishBar;
